// extracted by mini-css-extract-plugin
export var grid = "_l-0";
export var span1 = "_l-2";
export var span10 = "_l-b";
export var span10L = "_l-z";
export var span10M = "_l-n";
export var span10Xl = "_l-1b";
export var span11 = "_l-c";
export var span11L = "_l-10";
export var span11M = "_l-o";
export var span11Xl = "_l-1c";
export var span12 = "_l-d";
export var span12L = "_l-11";
export var span12M = "_l-p";
export var span12Xl = "_l-1d";
export var span1L = "_l-q";
export var span1M = "_l-e";
export var span1Xl = "_l-12";
export var span2 = "_l-3";
export var span2L = "_l-r";
export var span2M = "_l-f";
export var span2Xl = "_l-13";
export var span3 = "_l-4";
export var span3L = "_l-s";
export var span3M = "_l-g";
export var span3Xl = "_l-14";
export var span4 = "_l-5";
export var span4L = "_l-t";
export var span4M = "_l-h";
export var span4Xl = "_l-15";
export var span5 = "_l-6";
export var span5L = "_l-u";
export var span5M = "_l-i";
export var span5Xl = "_l-16";
export var span6 = "_l-7";
export var span6L = "_l-v";
export var span6M = "_l-j";
export var span6Xl = "_l-17";
export var span7 = "_l-8";
export var span7L = "_l-w";
export var span7M = "_l-k";
export var span7Xl = "_l-18";
export var span8 = "_l-9";
export var span8L = "_l-x";
export var span8M = "_l-l";
export var span8Xl = "_l-19";
export var span9 = "_l-a";
export var span9L = "_l-y";
export var span9M = "_l-m";
export var span9Xl = "_l-1a";
export var stretch = "_l-1";